<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <h4 v-if="!propOpenedInModal" class="card-title">{{ cvCardTitle }}</h4>
        <ValidationObserver ref="OrgProfile">
          <form action="#">
            <div class="form-row">
              <div class="col-md-12 mb-3" v-if="!vmOrgProfileFormData.org_id">
                <label for="validationorg_name">{{cvOrgIdLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="OrgId" rules="required|min:3" v-slot="{ errors }">
                  <input v-model="vmOrgProfileFormData.org_id" type="text" class="form-control" />
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <div class="col-md-12 mb-4">
                <div v-if="!vmOrgProfileFormData.org_name">
                  <label for="validationorg_name" class="text-secondary small">{{cvOrgNameLabel}}</label>
                  <span class="primary-color font-size-16">*</span>
                  <ValidationProvider name="OrgName" rules="required|min:3" v-slot="{ errors }">
                    <input v-model="vmOrgProfileFormData.org_name" type="text" class="form-control form-control-lg" placeholder="Enter University Name..." />
                    <span class="text-danger small">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
                <div v-else class="py-2 border-bottom">
                  <!-- Matches the clean, greyed typography in image_558178.png -->
                  <h5 class="text-primary mb-0 font-weight-normal">
                    <i class="fa fa-university" aria-hidden="true"></i> {{ vmOrgProfileFormData.org_name }}
                  </h5>
                </div>
              </div>

              <!-- Available Majors -->
              <div class="col-md-12 mb-3">
                <label>{{cvAvailableMajorsLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="AvailableMajors" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.available_majors"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Curriculum Design -->
              <div class="col-md-12 mb-3">
                <label>{{cvCurriculumDesignLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Curriculum Design" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.curriculum_design"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Structure Size -->
              <div class="col-md-12 mb-3">
                <label>{{cvStructureSizeLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Structure Size" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.structure_size"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Selectivity -->
              <div class="col-md-12 mb-3">
                <label>{{cvSelectivityLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Selectivity" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.selectivity"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Cost -->
              <div class="col-md-12 mb-3">
                <label>{{cvCostLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Cost" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.cost"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Weather -->
              <div class="col-md-12 mb-3">
                <label>{{cvWeatherLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Weather" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.weather"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Religiosity -->
              <div class="col-md-12 mb-3">
                <label>{{cvReligiosityLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Religiosity" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.religiosity"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Club Extracurriculars -->
              <div class="col-md-12 mb-3">
                <label>{{cvClubExtracurricularsLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="ClubExtracurriculars" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.club_extracurriculars"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Demographics -->
              <div class="col-md-12 mb-3">
                <label>{{cvDemographicsLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="Demographics" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.demographics"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Campus Living -->
              <div class="col-md-12 mb-3">
                <label>{{cvCampusLivingSituationLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="CampusLivingSituation" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.campus_living_situation"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Social Life -->
              <div class="col-md-12 mb-3">
                <label>{{cvSocialLifePersonalityLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="SocialLifePersonality" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.social_life_personality"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Average Annual Income -->
              <div class="col-md-12 mb-3">
                <label>{{cvAverageAnnualIncomeLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="AverageAnnualIncome" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.average_annual_income"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Average Graduate Debt -->
              <div class="col-md-12 mb-3">
                <label>{{cvAverageGraduateDebtLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="AverageGraduateDebt" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.average_graduate_debt"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

              <!-- Job Opportunities -->
              <div class="col-md-12 mb-3">
                <label>{{cvJobOpportunitiesLabel}}</label> <span class="primary-color font-size-16">*</span>
                <ValidationProvider name="JobOpportunities" rules="required" v-slot="{ errors }">
                  <vue-editor :editorToolbar="customToolbar" v-model="vmOrgProfileFormData.job_opportunities"></vue-editor>
                  <span class="text-danger">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>

            </div>
            <div class="form-group">
              <button v-if="cvLoadingStatus" type="button" class="btn btn-primary" disabled>
                <b-spinner small label="Spinning"></b-spinner>
              </button>
              <button v-else type="button" class="btn btn-primary" @click="OrgProfileAdd()"> {{ cvSubmitBtn }} </button>
            </div>
          </form>
        </ValidationObserver>
      </b-col>
    </b-row>
    <b-toast v-model="showToast" name="Toast" :auto-hide-delay="toastVariant === 'danger' ? 10000 : 1000" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>

<script>
import { OrgProfiles } from "../../../../FackApi/api/OrgProfile.js"
import ApiResponse from "../../../../Utils/apiResponse.js"
import { socialvue } from "../../../../config/pluginInit.js"
import userPermission from "../../../../Utils/user_permission.js"
import { VueEditor } from "vue2-editor"

export default {
  name: "OrgProfileAdd",
  props: {
    propOpenedInModal: {
      type: Boolean,
      default: false
    },
    propOrgDetails: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      cvCardTitle: "Add/Update Organisation Profile",
      cvSubmitBtn: "Add",
      cvOrgIdLabel: "Org Id",
      cvOrgNameLabel: "Org Name",
      cvAvailableMajorsLabel: "Available Majors",
      cvCurriculumDesignLabel: "Curriculum Design",
      cvStructureSizeLabel: "Structure Size",
      cvSelectivityLabel: "Selectivity",
      cvCostLabel: "Cost",
      cvWeatherLabel: "Weather",
      cvReligiosityLabel: "Religiosity",
      cvClubExtracurricularsLabel: "Club Extracurriculars",
      cvDemographicsLabel: "Demographics",
      cvCampusLivingSituationLabel: "Campus Living Situation",
      cvSocialLifePersonalityLabel: "Social Life Personality",
      cvAverageAnnualIncomeLabel: "Average Annual Income",
      cvAverageGraduateDebtLabel: "Average Graduate Debt",
      cvJobOpportunitiesLabel: "Job Opportunities",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      cvLoadingStatus: false,
      toastTitle: "Organisation Profile Info Added",
      vmOrgProfileFormData: Object.assign({}, this.initFormData()),
      vmOrgProfileDesc: null,
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ["bold", "italic", "underline", "strike"], // toggled buttons
        [{ "script": "super" }, { "script": "sub" }],
        [
          { align: "" },
          { align: "center" },
          { align: "right" },
          { align: "justify" }
        ],
        ["blockquote", "code-block"],
        [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ["link", "image", "video", "formula"],
        ["clean"] // remove formatting button
      ],
      vmOrgProfileType: null
    }
  },
  components: {
    VueEditor
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async beforeMount () {
    // Auth Access for Current User Role
    if (this.userData.user_role == "USERROLE11114") {
      // We will display only the sessions of the user, It is necessary when the user has multiple sessions and he/she wants to view the session
      // DONT CARE CASE
    }
    else if (!userPermission(this, this.userData, this.apiName)) {
      this.$router.back()
    }
    if (this.propOrgDetails) {
      this.vmOrgProfileFormData = {
        ...this.propOrgDetails,
        org_id: this.propOrgDetails.university_id || this.propOrgDetails.org_id
      }
    }
  },
  mounted () {
    socialvue.index()
  },
  methods: {
    /**
     * initFormData
     */
    initFormData () {
      return {
        "org_id": "",
        "org_name": "",
        "available_majors": "",
        "curriculum_design": "",
        "structure_size": "",
        "selectivity": "",
        "cost": "",
        "weather": "",
        "religiosity": "",
        "club_extracurriculars": "",
        "demographics": "",
        "campus_living_situation": "",
        "social_life_personality": "",
        "average_annual_income": "",
        "average_graduate_debt": "",
        "job_opportunities": ""
      }
    },
    /**
     * validate
     */
    validate () {
      try {
        for (let index in this.vmOrgProfileFormData) {
          if (!this.vmOrgProfileFormData[index]) {
            this.toastMsg = "Missing " + index.split("_").join(" ")
            this.toastVariant = "danger"
            this.showToast = true
            return false
          }
        }
        return true
      }
      catch (err) {
        console.error("Exception occurred at validate() and Exception:", err.message)
      }
    },
    /**
     * OrgProfileAdd
     */
    async OrgProfileAdd () {
      try {
        this.cvLoadingStatus = true
        let OrgProfileAddResp = await OrgProfiles.OrgProfileAdd(this, this.vmOrgProfileFormData)
        await ApiResponse.responseMessageDisplay(this, OrgProfileAddResp)
        if (OrgProfileAddResp && !OrgProfileAddResp.resp_status) {
          return false
        }
        //  Emit if opened in Modal
        if (this.propOpenedInModal) {
          this.$emit("emitCloseOrgProfileAddModal", OrgProfileAddResp.resp_data)
        }
        this.vmOrgProfileFormData = Object.assign({}, this.initFormData())
      }
      catch (err) {
        console.error("Exception occurred at OrgProfileAdd() and Exception:", err.message)
      }
      finally {
        this.cvLoadingStatus = false
      }
    }
  }
}
</script>
